import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { FormSectionHeader } from '../../../../../shared/form-section-header';
import SharedFormCheckbox from '../../../../../shared/shared-form-checkbox';
import { GroupTemplateFormData } from '../group-template-form-data';
import { primaryLanguageOptions } from '../group-template-form-options';
import { TemplateSelectField } from '../template-select-field';

interface BasicInfoStepProps {
  control: Control<GroupTemplateFormData>;
  errors: FieldErrors<GroupTemplateFormData>;
}

export default function BasicInfoStep({ control, errors }: BasicInfoStepProps) {
  return (
    <Stack gap={3}>
      <Stack gap={3}>
        <FormSectionHeader>General Information</FormSectionHeader>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Controller
              name="groupTemplateName"
              control={control}
              render={({ field }) => (
                <TextField
                  required
                  fullWidth
                  autoComplete="off"
                  inputProps={{ id: 'groupTemplateName' }}
                  InputLabelProps={{ htmlFor: 'groupTemplateName' }}
                  error={!!errors.groupTemplateName}
                  helperText={errors.groupTemplateName?.message || ' '}
                  label="Template Name"
                  value={field.value || ''}
                  onChange={field.onChange}
                />
              )}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Controller
              name="groupTemplateDesc"
              control={control}
              render={({ field }) => (
                <TextField
                  fullWidth
                  inputProps={{ id: 'groupTemplateDesc' }}
                  InputLabelProps={{ htmlFor: 'groupTemplateDesc' }}
                  label="Description"
                  value={field.value || ''}
                  onChange={field.onChange}
                  helperText=" "
                />
              )}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <TemplateSelectField
              name="primaryLanguage"
              control={control}
              label="Primary Language"
              helperText="This is the language that emails from the Google groups service will be sent in."
              options={primaryLanguageOptions}
            />
          </Grid>
        </Grid>
      </Stack>
      <Stack gap={2}>
        <Divider sx={{ width: '100%' }} />
        <SharedFormCheckbox
          control={control}
          name="allowWebPosting"
          label="Allow users to post to the group on the web"
        />
        <Divider sx={{ width: '100%' }} />
        <SharedFormCheckbox
          control={control}
          name="includeInGlobalAddressList"
          label="Include this group in Global Address Lists"
          helperText="This option includes the group in your Google Apps Global Address List. When included in the list, the group becomes available to Google Apps Sync for Microsoft Outlook users."
        />
        <Divider sx={{ width: '100%' }} />
        <SharedFormCheckbox
          control={control}
          name="isArchived"
          label="Archive messages to the group"
          helperText="When this option is unchecked, messages sent to the group will not be archived. Previously received messages will remain archived. Only archived messages are visible through the web interface."
        />
      </Stack>
    </Stack>
  );
}
